import type { EquipmentModel } from "./EquipmentModel";
import type {
  Equipment,
  EquipmentModel as EquipmentModelType,
  EquipmentModelsPaginationRequest,
  EquipmentSearchRequest,
} from "./Equipment.typed";
import type { PaginatedResponse } from "../zekay/pagination";

export class EquipmentAdapter {
  constructor(private model: EquipmentModel) {}

  async getEquipmentModels(
    paginationParams?: EquipmentModelsPaginationRequest,
  ): Promise<PaginatedResponse<EquipmentModelType> | EquipmentModelType[]> {
    return this.model.getEquipmentModels(paginationParams);
  }

  async getEquipmentModel(id: number): Promise<EquipmentModelType> {
    return this.model.getEquipmentModel(id);
  }

  async createEquipmentModel(model: EquipmentModelType): Promise<void> {
    return this.model.createEquipmentModel(model);
  }

  async updateEquipmentModel(model: EquipmentModelType): Promise<void> {
    return this.model.updateEquipmentModel(model);
  }

  async deleteEquipmentModel(id: number): Promise<void> {
    return this.model.deleteEquipmentModel(id);
  }

  async getEquipments(): Promise<Equipment[]> {
    return this.model.getEquipments();
  }

  async getEquipment(id: string): Promise<Equipment> {
    return this.model.getEquipment(id);
  }

  async createEquipment(equipment: Equipment): Promise<void> {
    return this.model.createEquipment(equipment);
  }

  async updateEquipment(equipment: Equipment): Promise<void> {
    return this.model.updateEquipment(equipment);
  }

  async deleteEquipment(id: string): Promise<void> {
    return this.model.deleteEquipment(id);
  }

  async getEquipmentQRCode(id: string): Promise<Blob> {
    return this.model.getEquipmentQRCode(id);
  }

  async regenerateEquipmentQRCode(id: string, backgroundColor?: string): Promise<void> {
    return this.model.regenerateEquipmentQRCode(id, backgroundColor);
  }

  async getEquipmentsByModelID(
    modelId: number,
    page?: number,
    limit?: number,
  ): Promise<{ equipments: Equipment[]; total: number; pages: number }> {
    return this.model.getEquipmentsByModelID(modelId, page, limit);
  }

  async searchEquipmentsByModelID(
    searchRequest: EquipmentSearchRequest,
  ): Promise<{ equipments: Equipment[]; total: number; pages: number }> {
    return this.model.searchEquipmentsByModelID(searchRequest);
  }

  async exportEquipmentsByModelIDCSV(modelId: number): Promise<Blob> {
    return this.model.exportEquipmentsByModelIDCSV(modelId);
  }

  async searchEquipmentsBatch(
    requests: EquipmentSearchRequest[],
  ): Promise<Array<{ total: number }>> {
    return this.model.searchEquipmentsBatch(requests);
  }
}
